import { Menu } from '../../views/twig/components/Menu';
import { Gallery } from '../../views/twig/modules/gallery';
import { Accordion } from '../../views/twig/modules/accordion';
import { ScrollSpy } from '../../views/ts/components/ScrollSpy';
(new Menu()).init();
(new Gallery()).init();
(new Accordion()).init();
(new ScrollSpy()).init();
